import React from 'react';
import PropTypes from 'prop-types';
import Table from 'react-toolbox/lib/table/Table';
import TableHead from 'react-toolbox/lib/table/TableHead';
import TableRow from 'react-toolbox/lib/table/TableRow';
import TableCell from 'react-toolbox/lib/table/TableCell';

const Listing = ({clinics, select, selected}) => {
    const selectTourFromIndex = (indices) => select(clinics[indices[0]]);

    return (
        <React.Fragment>
            <Table className='small-screen' onRowSelect={selectTourFromIndex}>
                {clinics.map((clinic, idx) => (
                    <TableRow key={idx} selected={clinic.id === (selected || {}).id}>
                        <TableCell style={{padding: 0}}>
                            <ul>
                                <li>{clinic.date}</li>
                                <li>{clinic.place}</li>
                                <li>${clinic.price} ({clinic.spots} spots)</li>
                            </ul>
                        </TableCell>
                    </TableRow>
                ))}
            </Table>
            <Table className='large-screen' onRowSelect={selectTourFromIndex}>
                <TableHead displaySelect={false}>
                    <TableCell>Dates</TableCell>
                    <TableCell>Place</TableCell>
                    <TableCell style={{textAlign: 'center'}}>Spots</TableCell>
                    <TableCell>price</TableCell>
                </TableHead>
                {clinics.map((clinic, idx) => (
                    <TableRow key={idx} selected={clinic.id === (selected || {}).id}>
                        <TableCell>{clinic.date}</TableCell>
                        <TableCell>{clinic.place}</TableCell>
                        <TableCell style={{textAlign: 'center'}}>{clinic.spots}</TableCell>
                        <TableCell>${clinic.price}</TableCell>
                    </TableRow>
                ))}
            </Table>
        </React.Fragment>
    )
};

Listing.propTypes = {
    clinics:  PropTypes.array.isRequired,
    select:   PropTypes.func.isRequired,
    selected: PropTypes.object
};

export default Listing;



// WEBPACK FOOTER //
// ./src/app/clinics/components/Listing.js